import {
  PickersLayoutContentWrapper,
  PickersLayoutRoot,
  pickersLayoutClasses,
  usePickerLayout,
  type PickersLayoutProps,
} from '@mui/x-date-pickers';
import type { DateRange } from '@mui/x-date-pickers-pro';
import type { DateTime } from 'luxon';
import useStyles from './styles';
import DynamicView, { type DynamicRangeType } from './DynamicView';
import type { DynamicRangeIntervalTimestep } from 'app-components/utils/date';
import React from 'react';

type CustomLayoutProps = PickersLayoutProps<DateRange<DateTime>, DateTime, 'day'> & {
  showDynamicView?: boolean;
  onDynamicClose?: () => void;
  onDynamicDateChange?: (
    start: DateTime,
    end: DateTime,
    interval?: DynamicRangeIntervalTimestep,
    count?: number,
  ) => void;
  dynamicSelection: DynamicRangeType;
  handleChangeDynamicSelection?: (sel: DynamicRangeType) => void;
  startDate?: DateTime;
  dateRangeInterval?: DynamicRangeIntervalTimestep; // used by dynamic view
  dateRangeIntervalCount?: number; // used by dynamic view
  minDate?: DateTime | null;
};

function CustomLayout(props: CustomLayoutProps) {
  const { shortcuts, content, actionBar, toolbar } = usePickerLayout(props);
  const { classes } = useStyles();
  const {
    showDynamicView,
    onDynamicDateChange,
    dynamicSelection,
    handleChangeDynamicSelection,
    startDate,
    dateRangeInterval,
    dateRangeIntervalCount,
    minDate,
  } = props;

  return (
    <PickersLayoutRoot className={classes.datePickerPopover} ownerState={props}>
      {shortcuts}
      <PickersLayoutContentWrapper className={pickersLayoutClasses.contentWrapper}>
        {showDynamicView ? (
          <DynamicView
            onDateRangeChange={onDynamicDateChange}
            onSelectionChange={handleChangeDynamicSelection}
            {...{ dynamicSelection, startDate, dateRangeInterval, dateRangeIntervalCount, minDate }}
          />
        ) : (
          <>
            {toolbar}
            {content}
          </>
        )}
      </PickersLayoutContentWrapper>
      {actionBar}
    </PickersLayoutRoot>
  );
}

export default CustomLayout;
